import { render, staticRenderFns } from "./MatchNameInput.vue?vue&type=template&id=70f70eda&"
import script from "./MatchNameInput.vue?vue&type=script&lang=js&"
export * from "./MatchNameInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports